export default "__VITE_ASSET__BobKeK5b__"